import { isEqual } from 'lodash-es';

type ActiveEffect = {
  fn: (...any) => any,
  params: any,
  promise: Promise<any>
}
const cache: ActiveEffect[] = [];

const timeout = 600;

const takeFirst = function<T extends (...args) => any> (callback: T, ...args: Parameters<T>): Promise<ReturnType<T>> {
  const activeEffect = cache
      .find(({ fn, params }) => fn === callback && isEqual(params, args));

  if (activeEffect) {
    return activeEffect.promise;
  }

  const newEffect: ActiveEffect = {
    fn: callback,
    params: args,
    promise: new Promise((resolve) => {
      setTimeout(() => {
        const index = cache.indexOf(newEffect);
        index > -1 && cache.splice(index, 1);
      }, timeout);
      resolve(callback(...args));
    })
  };
  cache.push(newEffect);
  return newEffect.promise;
};

export default takeFirst;
